import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import gapbgimage from "assets/svg/Inn.svg";

const useStyles = makeStyles({
  root: {
    backgroundImage: `url(${gapbgimage})`,
    /* background-color: #efefef;
  background: radial-gradient(rgb(255, 255, 255), rgb(200, 200, 200)); */
    //backgroundColor: "#efefef",
    width: "100%",
    height: "11vh",
    padding: "0px",
    margin: "0px",
    //display: "flex",
  },
});

function GapwithBG() {
  const classes = useStyles();
  return <div className={classes.root}></div>;
}

export default GapwithBG;
